export default __webpack_public_path__ + "static/media/bg3.6584b707.jpg";